// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__zw5fP","loader":"style_loader__qX-Sl","rotate360":"style_rotate360__d2FK2","child":"style_child__ce2ny","rotate":"style_rotate__AtI2Z"};